import React, { useState } from 'react'
import './styles/button.scss'

const Button = (props) => {
    const {
        children, cssClass, onClick, label, icon, style, type, title, disabled, id, size, variant,
    } = props

    const [loading, setLoading] = useState(false)

    let componentClass = 'uc-button'
    componentClass += (icon || loading) ? ' icon-btn' : ''
    componentClass += cssClass ? ` ${cssClass}` : ''
    componentClass += size ? ` ${size}` : ''
    componentClass += variant ? ` ${variant}` : ''

    const handleClick = async (e) => {
        if (loading) return
        setLoading(true)
        try {
            await onClick(e)
        } catch (error) {
            console.log('Button error ', error)
        }
        setLoading(false)
    }

    return (
        <button
            type={type || 'button'}
            className={componentClass}
            onClick={handleClick}
            style={style}
            title={title}
            disabled={disabled || loading}
            id={id}
        >
            {loading ? <i className="fa-solid fa-loader fa-spin" /> : null}
            {!loading && icon ? <i className={icon} /> : null}
            <b>{label}</b>
            {children}
        </button>
    )
}

export default Button
